import { ActionTypes } from "../constants";
export default function transactionState(state = {}, action) {
  switch (action.type) {
    case ActionTypes.SET_USER_TRANSACTION_STATE:
      return Object.assign({}, state, action.payload);

    default:
      return state;
  }
}
